import { Project } from '@bulthaup/api/db';
import { ActionIcon, Menu } from '@mantine/core';
import { IconDotsVertical, IconTrash } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';

import { trpc } from '../../../../services/trpc';

export function DeleteProjectButton({ project }: { project: Project }) {
  const navigate = useNavigate();
  const deleteProject = trpc.projects.delete.useMutation({
    onSuccess: () => {
      navigate({ to: '/app/projets' });
    },
  });

  const handleDelete = async () => {
    if (
      window.confirm(
        `Êtes-vous sûr de vouloir supprimer le projet "${project.name}" ? Cette action est irréversible.`,
      ) &&
      window.confirm(`VOUS ÊTES VRAIMENT VRAIMENT SUR ?`)
    ) {
      await deleteProject.mutateAsync({ id: project.id });
    }
  };

  return (
    <Menu shadow="md" width={200} position="bottom-start">
      <Menu.Target>
        <ActionIcon variant="subtle" size="lg">
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconTrash size={14} />}
          color="red"
          onClick={handleDelete}
          disabled={deleteProject.isPending}
        >
          Supprimer
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
